import { Controller } from "@hotwired/stimulus"

// General-purpose actions shared across views (printing, etc.)
export default class extends Controller {
  printPage() {
    window.print()
  }
}
